import React from 'react';
import type { V2AgreementItem } from '../types';

/** What the patient reads before agreeing: the legacy text, or a form-builder
 *  agreement's paragraphs (its `static_text` fields, section headings kept). */
export function agreementReviewText(item: V2AgreementItem): string {
  if (item.mode === 'text') return item.content;
  const parts: string[] = [];
  item.sections.forEach((section) => {
    const paragraphs = section.fields
      .filter((f) => f.field_type === 'static_text' && (f.content ?? '').trim())
      .map((f) => (f.content ?? '').trim());
    if (!paragraphs.length) return;
    if (section.label) parts.push(section.label.toUpperCase());
    parts.push(...paragraphs);
  });
  return parts.length ? parts.join('\n\n') : item.name;
}

export function V2AgreementReviewStep({ item, agreed, onToggleAgree }: {
  item: V2AgreementItem;
  agreed: boolean;
  onToggleAgree: (checked: boolean) => void;
}) {
  return (
    <div className="space-y-4">
      <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{item.name}</h3>
      {/* The legal text reads inline in the page scroll — a document, not a box.
          On phones it runs edge-to-edge past the content gutter. */}
      <div className="bg-gray-50 -mx-5 px-5 py-4 sm:mx-0 sm:rounded-2xl sm:border sm:border-gray-100 sm:p-4 text-[15px] sm:text-sm text-gray-700 leading-relaxed whitespace-pre-wrap font-sans">
        {agreementReviewText(item)}
      </div>
      <label className="flex items-center gap-4 min-h-[56px] p-4 rounded-xl border-2 border-gray-100 hover:border-primary/30 transition-all cursor-pointer group">
        <input
          type="checkbox"
          className="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary"
          checked={agreed}
          onChange={(e) => onToggleAgree(e.target.checked)}
        />
        <span className="text-sm font-semibold text-gray-700 group-hover:text-gray-900">
          I have read and agree to this document
          {item.required && <span className="text-primary-deep ml-1">*</span>}
        </span>
      </label>
    </div>
  );
}
